import { GeneticType } from 'app/api/products/types';

export const geneticTypeLabel: Record<GeneticType, string> = {
  [GeneticType.hybrid]: 'Hybrid',
  [GeneticType.openPollinated]: 'Open Pollinated',
};
